import React from 'react';
import CheckboxField from '@shared/components/CheckboxField';
import cx from 'classnames';

/**
 * @typedef {object} EventRegionSelectionProps
 * @property {Object} [regionData]
 * @property {boolean} [disabled]
 * @property {boolean} [hasError]
 * @property {boolean} [loading]
 * @property {(name: string, checked: boolean) => void} [setValue]
 */

/**
 * @param {EventRegionSelectionProps} props
 */
const EventRegionSelection = props => {
  const { regionData = {}, disabled, setValue, loading, hasError } = props;
  return (
    <div className={cx({ hasError: hasError })}>
      <CheckboxField
        title='Africa'
        name='eventTakesPlacesInAfrica'
        checked={regionData.eventTakesPlacesInAfrica}
        handleChange={setValue}
        loading={loading}
        disabled={disabled}
      />
      <CheckboxField
        title='Asia'
        name='eventTakesPlacesInAsia'
        checked={regionData.eventTakesPlacesInAsia}
        handleChange={setValue}
        loading={loading}
        disabled={disabled}
      />
      <CheckboxField
        title='Australia'
        name='eventTakesPlacesInAustralia'
        checked={regionData.eventTakesPlacesInAustralia}
        handleChange={setValue}
        loading={loading}
        disabled={disabled}
      />
      <CheckboxField
        title='Europe'
        name='eventTakesPlacesInEurope'
        checked={regionData.eventTakesPlacesInEurope}
        handleChange={setValue}
        loading={loading}
        disabled={disabled}
      />
      <CheckboxField
        title='North America'
        name='eventTakesPlacesInNorthAmerica'
        checked={regionData.eventTakesPlacesInNorthAmerica}
        handleChange={setValue}
        loading={loading}
        disabled={disabled}
      />
      <CheckboxField
        title='South America'
        name='eventTakesPlacesInSouthAmerica'
        checked={regionData.eventTakesPlacesInSouthAmerica}
        handleChange={setValue}
        loading={loading}
        disabled={disabled}
      />
    </div>
  );
};

export default EventRegionSelection;
